import { Outlet, createFileRoute } from '@tanstack/react-router'
import { Suspense } from 'react'
import { z } from 'zod'
import { AppLoader } from '~/components/loader'
import { useCurrentUser } from '~/hooks'
import { Nav } from '~/templates/settings'
import { SettingsTitle, SettingsTitleProvider } from '~/templates/settings/title'

const searchSchema = z.object({
  returnTo: z
    .object({
      to: z.string(),
      search: z.any(),
      params: z.record(z.string(), z.string()),
    })
    .optional(),
  page: z.number().optional(),
  query: z.string().optional(),
  sort: z
    .array(
      z.object({
        id: z.string(),
        desc: z.boolean(),
      }),
    )
    .optional(),
  filters: z.record(z.string(), z.unknown()).optional(),
  scrollTo: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/$alias/settings')({
  component: RouteComponent,
  validateSearch: searchSchema,
})

function RouteComponent() {
  const currentUser = useCurrentUser()
  if (!currentUser) return <AppLoader />
  return (
    <div className="bg-accent absolute inset-0 grid overflow-hidden p-4">
      <div className="bg-background flex overflow-hidden rounded-md border">
        <Nav />
        <div className="flex flex-1 flex-col overflow-y-auto">
          <SettingsTitleProvider>
            <SettingsTitle />
            <Suspense fallback={<AppLoader />}>
              <Outlet />
            </Suspense>
          </SettingsTitleProvider>
        </div>
      </div>
    </div>
  )
}
